import UserNotifications from '../components/notifications'

export default [
  {name: 'UserNotifications', path: '/notifications', component: UserNotifications},
]
